import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap, tap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserActions, userFeature } from '@state/user';
import { Router } from '@angular/router';
import { AuthenticationService, MeService, MsisdnService } from '@core/services';
import { AppRouting, VerificationType } from '@core/enums';
import { VerificationService } from '@core/services/verification.service';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { GeneralActions } from '../general';

@Injectable()
export class UserEffects {
  loadUsageDetails = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.getUserDetails),
      switchMap(() =>
        this.meService.getUserDetails().pipe(
          map((user) => ({
            ...user,
          })),
          map((user) => UserActions.getUserDetailsSuccess(user)),
          catchError(() => of(UserActions.getUserDetailsFailure()))
        )
      )
    );
  });
  refreshUserAfterEmailChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.changeEmailSuccess),
      map(() => UserActions.getUserDetails())
    )
  );
  //TODO: need to redirect to login page? when user change email and navigates to a link
  // checkUserIsEmpty$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(UserActions.getUserDetails),
  //       concatLatestFrom(() => this.store.select(userFeature.selectCurrent)),
  //       tap(([_, user]) => {
  //         if (user === null || user?.email.length === 0) {
  //           this.router.navigate([AppRouting.Login]);
  //         }
  //       })
  //     ),
  //   { dispatch: false }
  // );
  changeUserEmail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.changeEmail),
      switchMap(({ email }) =>
        this.verificationService.performActionWithVerification(VerificationType.Sms).pipe(
          map((verificationState) => ({
            verificationState,
            email,
          }))
        )
      ),
      concatLatestFrom(() => this.store.select(userFeature.selectSelectedMsisdnNumber)),
      switchMap(([{ verificationState, email }, msisdn]) =>
        verificationState.isVerified
          ? this.meService.updateEmail(msisdn, email).pipe(
              map((_) => UserActions.changeEmailSuccess(email)),
              catchError(() => of(UserActions.changeEmailFailure()))
            )
          : of(UserActions.changeEmailFailure())
      )
    );
  });
  // comment: ask not to logout after email changing
  // logoutAfterChange = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(UserActions.changeEmailSuccess),
  //     tap(() => {
  //       localStorage.clear();
  //       this.authenticationService.logout();
  //       this.router.navigate([AppRouting.Login]);
  //     }),
  //     map(() => UserActions.signOut())
  //   );
  // });
  changeUserPassword$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.changePassword),
      switchMap(({ newPassword, oldPassword }) =>
        this.verificationService.performActionWithVerification(VerificationType.Sms).pipe(
          map((verificationState) => ({
            verificationState,
            newPassword,
            oldPassword,
          }))
        )
      ),
      switchMap(({ verificationState, newPassword, oldPassword }) =>
        verificationState.isVerified
          ? this.meService.updatePassword(oldPassword, newPassword).pipe(
              map((_) => UserActions.changePasswordSuccess()),
              catchError(() => of(UserActions.changePasswordFailure()))
            )
          : of(UserActions.changePasswordFailure())
      )
    );
  });
  updateUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.updateUser),
      switchMap(({ payload }) =>
        this.verificationService
          .performActionWithVerification(VerificationType.Sms)
          .pipe(map((verificationState) => ({ verificationState, payload })))
      ),
      concatLatestFrom(() => this.store.select(userFeature.selectSelectedMsisdnNumber)),
      switchMap(([{ verificationState, payload }, msisdn]) =>
        verificationState.isVerified
          ? this.meService.updateUser(msisdn, payload).pipe(
              map(() => UserActions.updateUserSuccess(payload)),
              catchError(() => of(UserActions.updateUserFailure()))
            )
          : of(UserActions.updateUserFailure())
      )
    );
  });

  resolvePortingBlock$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.resolvePortingBlock),
      concatLatestFrom(() => this.store.select(userFeature.selectSelectedMsisdnNumber)),
      switchMap(([{ payload }, msisdn]) =>
        this.msisdnService.resolvePortingBlock(msisdn, payload).pipe(
          map(() => UserActions.resolvePortingBlockSuccess()),
          catchError(() => of(UserActions.resolvePortingBlockFailure()))
        )
      )
    );
  });

  refreshUserPrivacyAfterUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.updateUserSuccess),
      map(() => GeneralActions.getPrivacySettings())
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly router: Router,
    private readonly store: Store,
    private readonly authenticationService: AuthenticationService,
    private readonly verificationService: VerificationService,
    private readonly meService: MeService,
    private readonly msisdnService: MsisdnService
  ) {}
}
